import { generateLongitudeModal } from '../LongitudeModal';
import { generateLatitudeModal } from '../LatitudeModal';

const comments = 'The event coordinates of approximately 100 earthquakes in this database are not known and the latitude and longitude are listed as 0.0. Therefore, to retrieve all the events from a particular country or state, leave the event coordinates search parameter blank and enter the country.';

export const EqLongitudeModal = generateLongitudeModal({ comments });

export const EqLatitudeModal = generateLatitudeModal({ comments });
